import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { Configurations } from './configuration';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  constructor(
    @Optional() public config?: Configurations,
  ) { }
}
